export default "__VITE_ASSET__3feb5363__"